import React from "react";
import { Helmet } from "react-helmet-async";
import { injectIntl, IntlShape } from "react-intl";
import { withOneColLayout } from "../../../../utils";
import PageSubheader from "../../../../components/PageSubheader";
import AppClientForm from "../form";

interface Props {
  intl: IntlShape;
  backURL: string;
}

const CreateAppClient = (props: Props) => {
  const { intl, backURL } = props;

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({
            id: "page.app.client.create.document.title",
          })}
        </title>
      </Helmet>

      <PageSubheader
        goBackEnabled
        goBackId="btn-back-api-key-create"
        goBackURL={backURL}
      />

      <AppClientForm {...props} edition={false} />
    </>
  );
};

export default withOneColLayout(injectIntl(CreateAppClient));
